'use no memo';
import type { FC } from 'react';
import React, { useContext } from 'react';
import { css, cssMap } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { PageCardContext } from '../PageCardContext.ts';

type TitleProps = { singleLine?: boolean; ariaLevelOverride?: number };

const baseStyle = css({
	color: token('color.text'),
	textDecoration: 'none',
	outline: 'none',
	'&:active, &:visited, &:hover, &:focus': {
		color: token('color.text'),
		textDecoration: 'none',
	},
});

const defaultStyle = css({
	font: token('font.heading.small'),
});

const singleLineStyle = css({
	display: 'block',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	minWidth: 0,
});

const appearanceTitleStyles = cssMap({
	grid: {
		marginBottom: token('space.050'),
	},
	list: {
		fontWeight: token('font.weight.regular'),
		font: token('font.body'),
	},
	'compact-list': {},
	'end-of-page': {
		font: token('font.heading.xxsmall'),
	},
	'compact-end-of-page': {
		font: token('font.body.small'),
	},
});

export const Title: FC<TitleProps> = ({ singleLine, ariaLevelOverride }) => {
	const {
		id,
		title: { text },
		appearance,
	} = useContext(PageCardContext);

	return (
		<div
			id={`content-title-${id}`}
			role="heading"
			aria-level={ariaLevelOverride ?? 2}
			css={[
				baseStyle,
				defaultStyle,
				appearanceTitleStyles[appearance],
				singleLine && singleLineStyle,
			]}
		>
			{text}
		</div>
	);
};
